import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import DialogService from 'primevue/dialogservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';
import App from './App.vue';

const RapidDivPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f2ff', 100: '#cce4ff', 200: '#99caff',
      300: '#66afff', 400: '#3395ff', 500: '#007bff',
      600: '#0062cc', 700: '#004999', 800: '#003166',
      900: '#001833', 950: '#000c1a',
    },
  },
});

const app = createApp(App);

app.use(PrimeVue, {
  theme: {
    preset: RapidDivPreset,
    options: { darkModeSelector: '[data-bs-theme="dark1"]' },
  },
  // Ensure PrimeVue overlays appear above any high-z modal wrappers
  zIndex: {
    modal:   100001,
    overlay: 100001,
    menu:    100001,
    tooltip: 100002,
  },
});
app.use(ToastService);
app.use(DialogService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);

app.mount('#vue-app');
